"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const BaseButton_1 = __importDefault(require("../../../elementKit/baseButton/BaseButton"));
require("./credentialActionInfoBlock.scss");
const blue_report_icon_svg_1 = __importDefault(require("../../../assets/images/icons/blue-report-icon.svg"));
const linkedin_logo_white_png_1 = __importDefault(require("../../../assets/images/socialIcons/linkedin-logo-white.png"));
const blockchain_icon_svg_1 = __importDefault(require("../../../assets/images/icons/blockchain-icon.svg"));
const Events_1 = require("../../../services/backend/Events");
const tooltip_icon_svg_1 = __importDefault(require("../../../assets/images/icons/tooltip-icon.svg"));
const PdfDownload_1 = require("../../../services/backend/PdfDownload");
const Ims_1 = require("../../../services/backend/Ims");
const QrDownload_1 = require("../../../services/backend/QrDownload");
const credentialActionInfoBlockTranslations_json_1 = __importDefault(require("./credentialActionInfoBlocktranslations/credentialActionInfoBlockTranslations.json"));
const mandatoryClaimBannerTranslations_json_1 = __importDefault(require("../mandatoryClaimBanner/mandatoryClaimBannerTranslations/mandatoryClaimBannerTranslations.json"));
const Notification_1 = __importDefault(require("../../../elementKit/notification/Notification"));
const react_toastify_1 = require("react-toastify");
const DownloadCredentialDropdown_1 = __importDefault(require("../downloadCredentialDropdown/DownloadCredentialDropdown"));
const services_1 = require("../../../services");
const react_svg_1 = require("react-svg");
const master_1 = require("../../../constants/master");
const subdomains_1 = require("../../../constants/subdomains");
const ElementBaseConfig_1 = require("../../../config/ElementBaseConfig");
const MandatoryClaimBanner_1 = __importDefault(require("../mandatoryClaimBanner/MandatoryClaimBanner"));
const claimingFlowUtils_1 = require("../../../services/utils/claimingFlowUtils");
const ActionShareButtons_1 = __importDefault(require("./components/actionShareButtons/ActionShareButtons"));
const MobileBottomShareSheet_1 = __importDefault(require("./components/mobileBottomShareSheet/MobileBottomShareSheet"));
const ImsJsonEmbedModal_1 = __importDefault(require("../imsJsonModal/ImsJsonEmbedModal"));
const react_bootstrap_1 = require("react-bootstrap");
const utils_1 = require("../../../utils");
function CredentialActionInfoBlock(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    props.addTranslation(credentialActionInfoBlockTranslations_json_1.default);
    props.addTranslation(mandatoryClaimBannerTranslations_json_1.default);
    const [isLoadingPdf, setIsLoadingPdf] = (0, react_1.useState)(false);
    const [isLoadingPng, setIsLoadingPng] = (0, react_1.useState)({
        certificate: false,
        badge: false,
    });
    const [isLoadingQr, setIsLoadingQr] = (0, react_1.useState)(false);
    const [isLoadingCertificateDownload, setIsLoadingCertificateDownload] = (0, react_1.useState)(false);
    const [imsJson, setImsJson] = (0, react_1.useState)({});
    const [jsonModalLoading, setJsonModalLoading] = (0, react_1.useState)(false);
    const [isJsonModalOpen, setIsJsonModalOpen] = (0, react_1.useState)(false);
    const isDisabledByMandatoryClaiming = props.mandatoryClaimingRequired ||
        (((_a = props.details) === null || _a === void 0 ? void 0 : _a.organization.organizationVCLs) &&
            ((_b = props.details) === null || _b === void 0 ? void 0 : _b.organization.organizationVCLs.length) > 0 &&
            ((_d = (_c = props.details) === null || _c === void 0 ? void 0 : _c.organization.organizationVCLs[0]) === null || _d === void 0 ? void 0 : _d.isClaimingMandatory) &&
            !props.userMeta.userEmails
                .map((e) => e.value.toLowerCase())
                .includes(props.userEmail.toLowerCase())) ||
        false;
    const optimizedMixpanel = props.mixPanel
        ? new services_1.OptimizedMixPanel(props.mixPanel)
        : undefined;
    function getDisabledTooltipOptions() {
        return isDisabledByMandatoryClaiming
            ? {
                text: props
                    .translate((0, claimingFlowUtils_1.getClaimingDescTextKey)(props.userMeta, props.velocityOffer, props.userEmail))
                    .toString(),
                tooltipType: "info",
                showNotificationInsteadTooltip: props.isMobile,
            }
            : undefined;
    }
    const downloadPdf = () => __awaiter(this, void 0, void 0, function* () {
        try {
            setIsLoadingPdf(true);
            let response = yield (0, PdfDownload_1.generatePdfLink)(props.credential_no);
            setIsLoadingPdf(false);
            if (!(response === null || response === void 0 ? void 0 : response.hasError)) {
                yield (0, Events_1.logShareEventAnon)(props.credential_no, "pdf", props.details.organization.id);
                var downEl = document.createElement("a");
                downEl.setAttribute("href", response.data.link);
                downEl.setAttribute("download", props.credential_no);
                downEl.style.display = "none";
                document.body.appendChild(downEl);
                downEl.click();
                document.body.removeChild(downEl);
            }
        }
        catch (error) {
            console.log("pdf error", error);
            (0, Notification_1.default)({
                type: "error",
                text: props.translate("pdfDownloadError"),
            });
        }
    });
    const downloadPNG = (type) => __awaiter(this, void 0, void 0, function* () {
        try {
            setIsLoadingPng(type === "badge"
                ? { certificate: false, badge: true }
                : { certificate: true, badge: false });
            if (props.badgeUrl && props.certUrl) {
                if (type === "badge")
                    yield (0, Ims_1.downloadBakedPng)(props.credential_no);
                else {
                    var downEl = document.createElement("a");
                    downEl.setAttribute("href", props.certUrl);
                    downEl.setAttribute("download", props.credential_no);
                    downEl.style.display = "none";
                    document.body.appendChild(downEl);
                    downEl.click();
                    document.body.removeChild(downEl);
                }
            }
            else {
                yield (0, Ims_1.downloadBakedPng)(props.credential_no);
            }
            if (type === "badge") {
                yield (0, Events_1.logShareEventAnon)(props.credential_no, "badgePng", props.details.organization.id);
            }
            else {
                yield (0, Events_1.logShareEventAnon)(props.credential_no, "certificatePng", props.details.organization.id);
            }
            setIsLoadingPng({
                certificate: false,
                badge: false,
            });
        }
        catch (error) {
            console.log("png download error", error);
            setIsLoadingPng({
                certificate: false,
                badge: false,
            });
            (0, Notification_1.default)({
                type: "error",
                text: props.translate("pngDownloadError"),
            });
        }
    });
    const downloadJson = () => __awaiter(this, void 0, void 0, function* () {
        if (isJsonModalOpen) {
            setIsJsonModalOpen(false);
        }
        else {
            try {
                let imsJson = yield (0, Ims_1.getImsJson)(props.credential_no);
                if (!imsJson) {
                    (0, Notification_1.default)({
                        type: "error",
                        text: props.translate("jsonDownloadError"),
                    });
                    setJsonModalLoading(false);
                    setIsJsonModalOpen(false);
                    return;
                }
                setIsJsonModalOpen(true);
                optimizedMixpanel === null || optimizedMixpanel === void 0 ? void 0 : optimizedMixpanel.track("Ims JSON Download", {
                    credential_no: props.credential_no,
                    isLogged: props.userMeta.logged,
                    ownership: props.isLoggedInUser,
                });
                yield (0, Events_1.logShareEventAnon)(props.credential_no, "credentialJson", props.details.organization.id);
                setJsonModalLoading(false);
                setIsJsonModalOpen(true);
                setImsJson(imsJson);
            }
            catch (error) {
                console.log(error);
                setJsonModalLoading(false);
            }
        }
    });
    const downloadQrImg = () => __awaiter(this, void 0, void 0, function* () {
        try {
            setIsLoadingQr(true);
            const config = (0, master_1.getMasterConfig)();
            let body = {
                issuedTo: props.userFullName,
                credentialName: props.credentialTitle,
                issueDate: props.createDate,
                expiryDate: props.expireDate || "",
                issuedBy: props.issuedBy,
                credentialId: props.credential_no,
                logoImageUrl: config.subDomain === master_1.configFallback.subDomain || !config.logoLink
                    ? master_1.configFallback.logoLink
                    : config.logoLink,
                titleFontColor: config.primaryColor || (0, ElementBaseConfig_1.getElementkitConfig)().primaryGreenColor,
                verificationLink: window.location.href,
                labels: {
                    issuedTo: props.translate("issuedToQr"),
                    credentialName: props.translate("credNameQr"),
                    issueDate: props.translate("issueDate"),
                    expiryDate: props.expireDatePlain
                        ? props.translate("expireDate")
                        : "",
                    issuedBy: props.translate("issuedByQr"),
                    credentialId: props.translate("credId"),
                },
                organization_id: props.details.organization.id,
                recipient_group_id: props.details.recipientGroupId || "",
            };
            yield (0, QrDownload_1.generateQrWalletImg)(body);
            setIsLoadingQr(false);
        }
        catch (error) {
            console.log("download qr error", error);
            (0, Notification_1.default)({
                type: "error",
                text: props.translate("qrDownloadError"),
            });
            setIsLoadingQr(false);
        }
    });
    function getDownloadCredTranslationKey() {
        const config = (0, master_1.getMasterConfig)();
        return config.subDomain === subdomains_1.himssSubdomain
            ? "downloadCertificate"
            : "downloadCredential";
    }
    function getDropdownOptions() {
        var _a, _b, _c, _d;
        const options = [];
        if ((_a = props.details) === null || _a === void 0 ? void 0 : _a.certificateDesign) {
            options.push({
                key: "0",
                label: props.translate("certPNG").toString(),
            });
            options.push({ key: "3", label: props.translate("certPDF").toString() });
        }
        if (((_b = props.details) === null || _b === void 0 ? void 0 : _b.certificateDesign) || ((_c = props.details) === null || _c === void 0 ? void 0 : _c.badgeDesign)) {
            options.push({ key: "2", label: props.translate("qr").toString() });
            options.push({ key: "4", label: props.translate("json").toString() });
        }
        if ((_d = props.details) === null || _d === void 0 ? void 0 : _d.badgeDesign) {
            options.push({ key: "1", label: props.translate("badge").toString() });
        }
        if (props.isVelocityCredential) {
            options.push({ key: "5", label: props.translate("copyJson").toString() });
        }
        if (props.isVelocityCredential && props.downloadVelocityPng) {
            options.push({
                key: "6",
                label: props.translate("certPNG").toString(),
            });
        }
        // sort them by key
        options.sort((a, b) => {
            return parseInt(a.key) - parseInt(b.key);
        });
        return options;
    }
    const handlePrintedCertificateClick = () => {
        var _a;
        const certificateDesign = (_a = props.details) === null || _a === void 0 ? void 0 : _a.certificateDesign;
        if (!certificateDesign) {
            return;
        }
        const variantName = (0, utils_1.getVariantNameFromDimensions)(certificateDesign.widthPX, certificateDesign.heightPX);
        if (!variantName) {
            return;
        }
        const purchaseUrl = (0, utils_1.buildCertifydPurchaseUrl)(props.credential_no, variantName);
        window.open(purchaseUrl, "_blank", "noopener,noreferrer");
        // Track the event for analytics
        optimizedMixpanel === null || optimizedMixpanel === void 0 ? void 0 : optimizedMixpanel.track("Get Printed Version Clicked", {
            credential_no: props.credential_no,
            variant: variantName,
            isLogged: props.userMeta.logged,
            ownership: props.isLoggedInUser,
        });
    };
    return (react_1.default.createElement("div", { className: "action-info-block" },
        react_1.default.createElement(react_toastify_1.ToastContainer, null),
        props.isMobile && (react_1.default.createElement(MobileBottomShareSheet_1.default, Object.assign({ optimizedMixpanel: optimizedMixpanel, getDisabledTooltipOptions: getDisabledTooltipOptions, isDisabledByMandatoryClaiming: isDisabledByMandatoryClaiming }, props))),
        react_1.default.createElement("div", { className: "title-blockchain-cont" },
            react_1.default.createElement("span", { className: "cred-title dynamic-text-color" }, props.credentialTitle),
            props.isBlockchainSecured && (react_1.default.createElement("div", { className: "blockchain-row" },
                react_1.default.createElement("img", { src: blockchain_icon_svg_1.default, className: "blockchain-icon", alt: "blockchain", width: 16, height: 19 }),
                react_1.default.createElement("span", { className: "secured-text" }, props.translate("blockchainSecured").toString()),
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, null, props.translate("credentialSecuredByBlockchain").toString()) },
                    react_1.default.createElement("img", { src: tooltip_icon_svg_1.default, alt: "tooltip-icon", className: "blockchain-tooltip-icon", id: "tooltip-secure-credential" }))))),
        react_1.default.createElement("div", { className: "action-buttons" },
            react_1.default.createElement("div", { className: "btn-row jc-sb" },
                !props.isMobile ? (react_1.default.createElement(BaseButton_1.default, { type: "primary", size: "small", loading: false, disabled: isDisabledByMandatoryClaiming, height: 50, width: props.isMobile ? undefined : 270, className: "full-width-mobile-btn", primaryColor: "#0072B1", disabledButtonTooltipOptions: getDisabledTooltipOptions(), onClickAction: () => {
                        props.handleLinkedinClickOpen();
                    } }, props.activeLanguage && props.activeLanguage.code === "tr" ? (react_1.default.createElement("div", { className: "flex-row ai-fe" },
                    react_1.default.createElement("img", { alt: "LinkedIn Logo", className: "linkedin-logo white", src: linkedin_logo_white_png_1.default, width: "75", height: "20", loading: "lazy" }),
                    react_1.default.createElement("span", null, props.translate("addToLinkedin").toString()))) : (react_1.default.createElement("div", { className: "flex-row ai-fe" },
                    react_1.default.createElement("span", null, props.translate("addToLinkedin").toString()),
                    react_1.default.createElement("img", { alt: "LinkedIn Logo", className: "linkedin-logo white", src: linkedin_logo_white_png_1.default, width: "75", height: "20", loading: "lazy" }))))) : null,
                !props.isMobile && (react_1.default.createElement(ActionShareButtons_1.default, Object.assign({}, props, { optimizedMixpanel: optimizedMixpanel, getDisabledTooltipOptions: getDisabledTooltipOptions, isDisabledByMandatoryClaiming: isDisabledByMandatoryClaiming })))),
            react_1.default.createElement("div", { className: "btn-row jc-sb", style: {
                    marginTop: "20px",
                } },
                react_1.default.createElement(BaseButton_1.default, { type: "primary", size: "small", loading: false, height: 50, width: props.isMobile ? undefined : 270, className: "full-width-mobile-btn", onClickAction: () => {
                        optimizedMixpanel === null || optimizedMixpanel === void 0 ? void 0 : optimizedMixpanel.track("Verify Dialog Opened", {
                            credential_no: props.credential_no,
                            isLogged: props.userMeta.logged,
                            ownership: props.isLoggedInUser,
                        });
                        props.handleVerifyDialogOpen();
                    } },
                    react_1.default.createElement("span", null, props.translate("verifyCredentialBase").toString())),
                react_1.default.createElement(DownloadCredentialDropdown_1.default, { disabled: isDisabledByMandatoryClaiming, disabledButtonTooltipOptions: getDisabledTooltipOptions(), placeholder: props
                        .translate(props.isVelocityCredential
                        ? "exportCredential"
                        : getDownloadCredTranslationKey())
                        .toString(), dropdownOptions: getDropdownOptions(), isJsonLoading: jsonModalLoading, isPdfLoading: isLoadingPdf, isCertificatePngLoading: isLoadingCertificateDownload, isBadgePngLoading: isLoadingPng.badge, isQrLoading: isLoadingQr, onChangeAction: (value) => {
                        if (isLoadingPdf ||
                            isLoadingPng.badge ||
                            isLoadingPng.certificate ||
                            isLoadingQr ||
                            jsonModalLoading) {
                            return;
                        }
                        else {
                            if (value === "0") {
                                // downloadCertificate();
                                downloadPNG("certificate");
                            }
                            if (value === "1") {
                                downloadPNG("badge");
                            }
                            if (value === "2") {
                                downloadQrImg();
                            }
                            if (value === "3") {
                                downloadPdf();
                            }
                            if (value === "4") {
                                downloadJson();
                            }
                            if (value === "5") {
                                props.handleCopyJson && props.handleCopyJson();
                                optimizedMixpanel === null || optimizedMixpanel === void 0 ? void 0 : optimizedMixpanel.track("Copy JSON", {
                                    credential_no: props.credential_no,
                                    isLogged: props.userMeta.logged,
                                    ownership: props.isLoggedInUser,
                                });
                            }
                            if (value === "6") {
                                props.downloadVelocityPng && props.downloadVelocityPng();
                            }
                            if (value !== "5" && value !== "4") {
                                optimizedMixpanel === null || optimizedMixpanel === void 0 ? void 0 : optimizedMixpanel.track("Download Credential", {
                                    credential_no: props.credential_no,
                                    Qr: value === "2",
                                    Certificate: value === "0",
                                    Badge: value === "1",
                                    PDF: value === "3",
                                    VelocityPng: value === "6",
                                    isLogged: props.userMeta.logged,
                                    ownership: props.isLoggedInUser,
                                });
                            }
                        }
                    }, width: 270, height: 50, isMobile: props.isMobile, value: "" }))),
        (props.velocityOffer != null || isDisabledByMandatoryClaiming) && (react_1.default.createElement(MandatoryClaimBanner_1.default, Object.assign({}, props, { mixpanel: props.mixPanel, velocityOffer: props.velocityOffer, userMeta: props.userMeta }))),
        react_1.default.createElement("div", { className: "bottom-col" },
            react_1.default.createElement("div", { className: "bottom-buttons-row" },
                ((_f = (_e = props.details) === null || _e === void 0 ? void 0 : _e.organization) === null || _f === void 0 ? void 0 : _f.printedCertificate) &&
                    ((_g = props.details) === null || _g === void 0 ? void 0 : _g.certificateDesign) && (react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", height: 50, loading: false, onClickAction: handlePrintedCertificateClick, className: "printed-certificate-btn" },
                    react_1.default.createElement("span", null, props.translate("getPrintedVersion").toString()))),
                react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", height: 50, loading: false, width: 50, onClickAction: () => props.openHelpModal(), className: "report-button" },
                    react_1.default.createElement(react_svg_1.ReactSVG, { className: "customizable-icon", wrapper: "svg", src: blue_report_icon_svg_1.default, width: 15, height: 15 })))),
        react_1.default.createElement(ImsJsonEmbedModal_1.default, Object.assign({}, props, { type: "json", jsonOptions: {
                downloadJson: downloadJson,
                imsJson: imsJson,
            }, hideModal: () => setIsJsonModalOpen(false), isJsonEmbedModalOpen: isJsonModalOpen, isMobile: props.isMobile, embedOptions: undefined }))));
}
exports.default = CredentialActionInfoBlock;
